// Collection-only deadline; deliberately independent of the cart's 11 a.m. rule.
const pacific = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit',
  day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
});
function wallTime(epoch) {
  const p = Object.fromEntries(pacific.formatToParts(epoch).map(p => [p.type, p.value]));
  return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
}
export function nextPacificMidnight(epoch) {
  if (!Number.isFinite(epoch)) throw new TypeError('A finite epoch is required');
  const local = new Date(wallTime(epoch));
  const target = Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate() + 1);
  let candidate = target;
  // Resolve the offset at the target midnight, including a DST change during today.
  for (let i = 0; i < 4; i++) candidate += target - wallTime(candidate);
  return candidate;
}
export function remainingLabel(epoch, deadline = nextPacificMidnight(epoch)) {
  const seconds = Math.max(0, Math.ceil((deadline - epoch) / 1000));
  return [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60]
    .map(n => String(n).padStart(2, '0')).join(':');
}
if (typeof customElements !== 'undefined' && !customElements.get('apolis-collection-rush')) {
  customElements.define('apolis-collection-rush', class extends HTMLElement {
    connectedCallback() {
      if (this.interval) return;
      this.clock = this.querySelector('[data-rush-clock]');
      this.sentence = this.querySelector('[data-rush-sentence]');
      if (!this.clock || !this.sentence) return;
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
      this.refresh = () => this.tick();
      document.addEventListener('visibilitychange', this.refresh);
    }
    tick() {
      const now = Date.now();
      if (!this.deadline || now >= this.deadline || now < this.lastNow) {
        this.deadline = nextPacificMidnight(now);
      }
      this.lastNow = now;
      this.clock.textContent = remainingLabel(now, this.deadline);
      this.sentence.style.visibility = 'visible';
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      this.interval = null;
      document.removeEventListener('visibilitychange', this.refresh);
    }
  });
}
